export default __webpack_public_path__ + "static/bg-black-card-b01081c373596e8b2ebb64bd27663db3.png";